var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 6,
    viewBox: "0 0 14 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3294 0.258221C12.739 -0.112166 13.3714 -0.0803177 13.7418 0.329355C14.1122 0.739029 14.0803 1.37139 13.6706 1.74178L12.3294 0.258221ZM0.329356 1.74178C-0.0803175 1.37139 -0.112165 0.739029 0.258222 0.329355C0.628609 -0.0803177 1.26097 -0.112166 1.67064 0.258221L0.329356 1.74178ZM6.05914 4.49631L6.5341 3.6163L6.05914 4.49631ZM13.6706 1.74178C11.7216 3.50395 10.3892 4.31123 8.41581 5.37632L7.4659 3.6163C9.35422 2.59714 10.5386 1.87727 12.3294 0.258221L13.6706 1.74178ZM1.67064 0.258221C3.46143 1.87727 4.64578 2.59714 6.5341 3.6163L5.58419 5.37632C3.61077 4.31123 2.27843 3.50395 0.329356 1.74178L1.67064 0.258221ZM8.41581 5.37632C7.53271 5.85295 6.46729 5.85295 5.58419 5.37632L6.5341 3.6163C6.82435 3.77295 7.17565 3.77295 7.4659 3.6163L8.41581 5.37632Z",
    fill: "#9F9F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.390e4e2af09138bc5c655ad685b6b8f0.svg";
export { ForwardRef as ReactComponent };